var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formattedNotes.length
        ? _c("v-client-table", {
            ref: "applicationNotesTable",
            staticClass: "vue-custom-table no-pagination",
            attrs: {
              data: _vm.formattedNotes,
              columns: _vm.appNotesColumns,
              options: _vm.appNotesOptions,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "notes",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n      " + _vm._s(row.notes.noteText) + "\n\n      "
                      ),
                      row.notes.noteText.length > _vm.maxInlineNoteLength
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link text-primary ml-2 p-0 expand-event",
                              staticStyle: { "font-size": "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.expandNote(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    row.notes.expanded
                                      ? _vm.$t("global.actions.showLess")
                                      : _vm.$t("global.actions.showMore")
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "delete",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link p-0 delete-note-event",
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(row)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "d-none" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("client-profile.actions.deleteNote")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("icon", {
                            staticClass: "text-danger",
                            attrs: { name: "trash" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              73581636
            ),
          })
        : _c(
            "no-results",
            {
              attrs: {
                "img-src": require("@Shared/@Assets/img/application-missing.png"),
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "internal-notes.messages.youNeedToAddAnInternalNoteFirst"
                    )
                  ) +
                  "\n  "
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }